import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSGlobeTagName: string = 'hhds-globe';
const TAG_NAME: string = HHDSGlobeTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSGlobeAttrNames = {};

//const Attrs = HHDSGlobeAttrNames;

export class HHDSGlobe extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = `
		<div class="${TAG_NAME}">
      <slot></slot>
      <span id="globe-skip"></span>
		</div>`;

		this.setInnerHtml('', '', html);

		this.addListeners();

		this.observeSlotChanges(true);
	}

	private onMessage(event: any): void {
		if (event.data.action === 'globeSkipScroll') {
			const globeSkipElement = document.getElementById('globe-skip');
			if (globeSkipElement) {
				const yPos = globeSkipElement.offsetTop;
				window.scrollTo({ top: yPos, behavior: 'smooth' });
			}
		}

		if (event.data.action === 'globeResizeHeight') {
			const iframe = document.getElementById('globe');
			if (iframe) {
				document.body.style.setProperty('--globe-calculated-height', `${event.data.height}px`);
			}
		}
	}

	private addListeners(): void {
		window.addEventListener('message', this.onMessage.bind(this));
	}

	private removeListeners(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'removeListeners');
		window.removeEventListener('message', this.onMessage.bind(this));
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
		this.removeListeners();
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
